export type AiChatSessionSummary = {
  id: string;
  title: string | null;
  routeContext: string | null;
  createdAt: string;
  updatedAt: string;
  messageCount: number;
};

export type StoredChatMessage = {
  id: string;
  role: 'user' | 'assistant';
  text: string;
  domain?: string | null;
  metadata?: unknown;
  createdAt: string;
};

export type AiChatSessionDetail = AiChatSessionSummary & {
  messages: StoredChatMessage[];
};

export function sessionDisplayTitle(session: AiChatSessionSummary): string {
  if (session.title?.trim()) return session.title.trim();
  if (session.messageCount > 0) return 'Conversación sin título';
  return 'Nueva conversación';
}

export function formatSessionDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('es-AR', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}
